<template>
  <div class="inside-wrapper">
    <button
      class="btn btn-info btn-block add-contact-btn"
      data-target="#newContactModal"
      data-toggle="modal"
      @click.prevent="addContact()"
    >
      Add new contact
    </button>
    <div v-if="showAddContactPopup" class="new-row">
      <div
        v-if="showAddContactPopup"
        id="newContactModal"
        aria-hidden="true"
        aria-labelledby="addContactModal"
        class="modal fade"
        data-backdrop="false"
        role="dialog"
        tabindex="-1"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header" style="display: flex; padding: 5px 15px;">
              <h4
                id="addContactModal"
                class="modal-title"
                style="margin-left:35%"
              >
                Add New Contact
              </h4>
              <button
                aria-label="Close"
                class="close"
                data-dismiss="modal"
                style="margin-left: auto"
                type="button"
              >
                <span aria-hidden="true" @click="cancelAddContact()"
                  >&times;</span
                >
              </button>
            </div>
            <div class="modal-body" style="display: flex">
              <form id="addContactForm">
                <div class="form__group">
                  <input
                    v-model="newContact.first_name"
                    type="text"
                    id="firstName"
                    class="form__field validate"
                    placeholder="First name"
                    autocomplete="off"
                    required
                  />
                  <i class="fas fa-user-circle input-icon"></i>
                  <label for="firstName" class="form__label">First name</label>
                </div>
                <div class="form__group">
                  <input
                    v-model="newContact.last_name"
                    type="text"
                    id="lastName"
                    class="form__field"
                    placeholder="Last name"
                    autocomplete="off"
                    required
                  />
                  <i class="far fa-user-circle input-icon"></i>
                  <label for="lastName" class="form__label">Last name</label>
                </div>
                <div class="form__group">
                  <input
                    v-model="newContact.email"
                    type="email"
                    id="email"
                    class="form__field"
                    placeholder="Email"
                    autocomplete="off"
                    required
                  />
                  <i class="fas fa-envelope input-icon"></i>
                  <label for="email" class="form__label">Email</label>
                </div>
                <CountrySelect :countries="dictionaries.general.countries" @selectCountry="setSelectedCountry"/>

                <div class="form__group">
                  <input
                    v-model="newContact.phone"
                    type="tel"
                    id="telInput"
                    class="form__field"
                    placeholder="Phone number"
                    autocomplete="off"
                    required
                  />
                  <i class="fas fa-phone input-icon"></i>
                  <label for="telInput" class="form__label">Phone number</label>
                  <span
                      class="reset-select"
                      @click="newContact.phone = ''"
                      v-if="newContact.phone"
                  ><i class="fas fa-times"></i
                  ></span>
                </div>
                <div class="form__group">
                  <input
                    v-model="newContact.address"
                    type="tel"
                    id="addressInput"
                    class="form__field"
                    placeholder="Address"
                    autocomplete="off"
                    required
                  />
                  <i class="fas fa-address-card input-icon"></i>
                  <label for="addressInput" class="form__label">Address</label>
                </div>
<!--                <div class="form__group">-->
<!--                  <input-->
<!--                    type="file"-->
<!--                    id="imageInput"-->
<!--                    class="form__field"-->
<!--                    placeholder="Profile image"-->
<!--                    autocomplete="off"-->
<!--                    required-->
<!--                  />-->
<!--                  <i class="fas fa-address-card input-icon"></i>-->
<!--                  <label for="imageInput" class="form__label">Profile image</label>-->
<!--                </div>-->
                <UploadFileInput :editMode="false" @selectImage="setProfileImage"/>
                <div class="form__group">
                  <textarea
                    v-model="newContact.comment"
                    id="message"
                    class="form__field"
                    placeholder="Comment"
                    rows="4"
                  ></textarea>
                  <label for="message" class="form__label">Comment</label>
                </div>
                <div class="btn-wrapper">
                  <button
                    v-if="showAddContactPopup"
                    class="btn btn-sm"
                    style="padding: 0.3rem; background-color: #100f11;color: white; font-size: 11px"
                    @click.prevent="cancelAddContact()"
                  >
                    CANCEL
                  </button>
                  <button
                    class="btn btn-sm"
                    style="padding: 0.3rem; background-color: #2ea591; color: white; font-size: 11px"
                    @click.prevent="saveNewContact()"
                  >
                    SAVE
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiClientCreator from "@/helpers/api/request";
import vClickOutside from "v-click-outside";
import { mapState } from "vuex";
import CountrySelect from "@/features/projects.feature/contacts/components/AddContactForm/CountrySelect.component";
import UploadFileInput from "@/features/projects.feature/contacts/components/AddContactForm/UploadFileInput.component";

export default {
  name: "AddContact",
  components: {UploadFileInput, CountrySelect},
  directives: {
    clickOutside: vClickOutside.directive
  },
  computed: {
    ...mapState("clients", ["dictionaries"])
  },
  data() {
    return {
      newContact: {
        address: "",
        comment: "",
        country: null,
        email: "",
        first_name: "",
        profile_img: '',
        last_name: "",
        phone: "",
        status_id: 1
      },
      openCountryList: false,
      showAddContactPopup: false
    };
  },
  methods: {
    addContact() {
      this.showAddContactPopup = !this.showAddContactPopup;
    },
    cancelAddContact() {
      this.showAddContactPopup = false;
      this.clearForm();
    },
    clearForm() {
      document.getElementById("addContactForm").reset();
    },
    async saveNewContact() {
      try {
        this.$store.commit("clients/setLoading", true);

        const addNewContactRequest = apiClientCreator(`projects/contacts/add`);

        const newContact = {
          first_name: this.newContact.first_name,
          last_name: this.newContact.last_name,
          email: this.newContact.email,
          phone: this.newContact.phone,
          address: this.newContact.address,
          comment: this.newContact.comment,
          status_id: this.newContact.status_id,
          profile_img: this.newContact.profile_img
        };

        await addNewContactRequest.post("", newContact).then(res => {
          this.$store.commit("main/setShowVikiMsg", {
            show: true,
            msg: "New Contact Added successfully",
            type: "DONE",
            op: { type: "SYSTEM" }
          });
          this.clearForm();
          this.showAddContactPopup = false;
          // $("#addContactModal").modal("hide");
          this.$emit('fetchContacts')

        });
        this.$store.commit("clients/setLoading", false);
      } catch (e) {
        this.$store.commit("main/setShowVikiMsg", {
          show: true,
          msg: `Error adding c: ${e} Error Status: `,
          type: "ERROR",
          op: { type: "SYSTEM" }
        });
        this.$store.commit("clients/setLoading", false);
        this.cancelAddContact();
      }
    },
    setSelectedCountry(country){
      this.newContact.country = country
      this.newContact.phone = country.area_code_main
    },
    setProfileImage(imgSrc){
      this.newContact.profile_img = imgSrc
    }
  }
};
</script>

<style scoped lang="scss">
$bgColor: #009788;
$borderColor: #01756a;

.new-row {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
form {
  width: 100%;
}
.inside-wrapper {
  padding: 0px 5px;
}
.add-contact-btn {
  height: 40px;
  background-color: $bgColor;
  border-color: $borderColor;
}
.add-contact-btn:focus,
.add-contact-btn:active {
  height: 40px;
  background-color: $borderColor;
  border-color: $bgColor;
}

/*Inputs custom style starts ############################################################# */
.form__group {
  position: relative;
  padding: 15px 0 0;
  margin-top: 10px;
}
.form__field {
  font-family: inherit;
  width: 100%;
  border: 0;
  border-bottom: 1px solid #d2d2d2;
  outline: 0;
  font-size: 16px;
  color: #212121;
  padding: 7px 0;
  background: transparent;
  transition: border-color 0.2s;
}

.form__field::placeholder {
  color: transparent;
}

.form__field:placeholder-shown ~ .form__label {
  font-size: 16px;
  cursor: text;
  top: 20px;
}

label,
.form__field:focus ~ .form__label {
  position: absolute;
  top: 0;
  display: block;
  transition: 0.2s;
  font-size: 12px;
  color: #9b9b9b;
}

.form__field:focus ~ .form__label {
  color: $bgColor;
}
.form__field:focus ~ .input-icon {
  color: $bgColor;
}

.form__field:focus {
  padding-bottom: 6px;
  border-bottom: 2px solid $bgColor;
}
/*Inputs custom style ends ############################################################# */
.modal-content {
  padding: 5% 5% 5% 7%;
}
.input-icon {
  position: absolute;
  left: -30px;
  top: 25px;
  font-size: 1.9rem;
}

.btn-wrapper {
  text-align: right;
}

.btn-wrapper button {
  margin-left: 10px;
  margin-top: 20px;
  height: 35px;
  opacity: 0.8;
}

.btn-wrapper button:hover {
  opacity: 1;
}
.reset-select {
  position: absolute;
  cursor: pointer;
}
input#file {
  display: inline-block;
  width: 100%;
  padding: 120px 0 0 0;
  height: 100px;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: url('https://cdn1.iconfinder.com/data/icons/hawcons/32/698394-icon-130-cloud-upload-512.png') center center no-repeat #e4e4e4;
  border-radius: 20px;
  background-size: 60px 60px;
}
</style>
